<template>
  <ContentSection side-navigation="white" class="z-20 bg-blue-500 text-white">
    <Container indent="default-but-on-mobile-lg">
      <div class="flex max-w-container-max flex-col gap-5 lg:flex-row sm:gap-10">
        <div class="w-full shrink-0 lg:ml-auto lg:max-w-96">
          <!-- TITLE MOBILE -->
          <h2
            v-if="data.heading"
            class="mb-11 typo-label-md lg:hidden"
            v-html="data.heading"
          />

          <!-- IMAGE -->
          <div class="w-full max-lg:flex max-lg:items-center max-lg:gap-6">
            <div
              v-animate-zoom-in-out
              class="
                aspect-square w-full max-w-32 overflow-hidden rounded-full
                lg:ml-auto lg:mt-6 lg:w-full lg:max-w-96
                sm:max-w-44
              "
            >
              <AppImage
                v-if="image"
                :src="image"
                :alt="useMapAltText(image)"
                class="size-full object-cover"
                :aspect-ratio="1"
              />
            </div>

            <h3 class="typo-body-xl lg:hidden">
              {{ name }}<span v-if="name && functionName">,</span>
              <br>
              {{ functionName }}
            </h3>
          </div>
        </div>

        <div class="w-full lg:col-span-2 lg:pl-20">
          <!-- TITLE DESKTOP -->
          <h2
            v-if="data.heading"
            class="mb-4 typo-label-lg max-lg:hidden"
            v-html="data.heading"
          />

          <!-- TEXT -->

          <figure v-animate-children-in-from-bottom class="relative max-w-[50rem] lg:pt-[0.75em]">
            <div class="absolute left-0 top-0 shrink-0 grow-0 -translate-x-full items-start">
              <IconQuote class="w-9 lg:w-20 max-lg:-ml-1" />
            </div>

            <!-- QUOTE -->
            <blockquote

              class="typo-body-2xl after:content-none before:content-none lg:typo-body-4xl"
              :cite="data.link"
              v-html="data.text"
            />

            <IconQuote class="ml-auto w-9 translate-x-[40%] rotate-180 lg:w-20 max-lg:mt-[-1.75em]" />

            <!-- NAME & FUNCTION  -->
            <figcaption
              v-if="teamMember"
              class="typo-body-2xl max-lg:hidden"
            >
              {{ name }}<span v-if="name && functionName">,</span>
              <br>
              {{ functionName }}
            </figcaption>
          </figure>

          <!-- LINK -->
          <AppButton
            v-if="data.link"
            :to="data.link"
            class="mt-12 lg:mt-20 max-lg:mx-auto"
            variant="outlined"
            icon="invert"
          >
            {{ data.link_text }}
          </AppButton>
        </div>
      </div>
    </Container>
  </ContentSection>
</template>

<script lang="ts" setup>
import type { ComponentsBrBrQuoteFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsBrBrQuoteFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const teamMember = ref(props.data?.team_member || {})

const image = computed(() => {
  return props.data.is_linking_teammember
    ? teamMember.value?.image
    : props.data.image
})

const name = computed(() => {
  return props.data.is_linking_teammember
    ? teamMember.value?.title
    : props.data.name
})

const functionName = computed(() => {
  return props.data.is_linking_teammember
    ? teamMember.value?.function
    : props.data.function
})
</script>
